module.exports = __webpack_public_path__ + "public/img/500-2x.0746dfd.png";